<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" [ngClass]="config || 'unconfigured'">
    <div class="card-status">
        <div class="content-container"><ng-content></ng-content></div>
        <div>
            <i id="{{integrationType}} Menu" [matMenuTriggerFor]="actionMenu" class="mdi mdi-dots-horizontal" role="link"></i>
            <mat-menu #actionMenu="matMenu">
                <button id="setup {{integrationType}}" mat-menu-item type="button" [disabled]="!disabled && !!config" (click)="onClickSetUp()">{{fSetup}}</button>
                <button id="edit {{integrationType}}" mat-menu-item type="button" [disabled]="!config" (click)="onClickEdit()">{{fEdit}}</button>
                <button id="delete {{integrationType}}" mat-menu-item type="button" [disabled]="!deleteEnabled || !config" (click)="onClickDelete()">{{fDelete}}</button>
            </mat-menu>
        </div>
    </div>
    @if (showHealth) {
        @if (status$ | async; as integrationStatus) {
            @if (integrationStatus.enabled && !!integrationStatus.integrationStatus) {
                <mat-divider style="margin-bottom: 5px"></mat-divider>
                @if (integrationStatus.integrationStatus.reviving) {
                    {{'integration_status.reviving' | translate}}
                } @else if (integrationStatus.integrationStatus.threat_reported) {
                    <mat-error>{{'integration_status.threat_reported' | translate}}</mat-error>
                } @else if (integrationStatus.integrationStatus.last_http_status != 200) {
                    @if (integrationStatus.integrationStatus.last_http_status == null) {
                        @switch (integrationStatus.integrationStatus.last_http_status) {
                            @case (0) {
                                {{'integration_status.http_status.0' | translate}}
                            }
                            @case (401) {
                                <mat-error>{{'integration_status.http_status.401' | translate}}</mat-error>
                            }
                            @case (403) {
                                <mat-error>{{'integration_status.http_status.403' | translate}}</mat-error>
                            }
                            @default {
                                <mat-error>{{'integration_status.http_status.other' | translate : {status_code: integrationStatus.integrationStatus.last_http_status || '...'} }}</mat-error>
                            }
                        }
                    }
                } @else if (integrationStatus.integrationStatus.last_heartbeat) {
                    <span style="color: green">{{'integration_status.last_heartbeat' | translate }}: {{ integrationStatus.integrationStatus.last_heartbeat | date : 'medium' }}</span>
                }
            }
        }
    }
</mat-card>
